<script setup lang="ts"></script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 11L10 8L7 5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
